import { faLaptopCode, faCogs, faShoppingCart, faBullhorn, faCloud, faChartLine } from '@fortawesome/free-solid-svg-icons';

const SERVICES_DATA = [
  {
    'title': 'Web Development and Design',
    'icon': faLaptopCode,
    'details': 'We specialize in creating visually stunning, responsive websites that are optimized for both desktop and mobile devices, ensuring a seamless user experience across all platforms.',
    'color': '#497282'
  },     
  {
    'title': 'Web Services and Automations',
    'icon': faCogs,
    'details': 'We offer scalable web services and automated solutions to streamline your business processes and enhance operational efficiency, saving you time and resources.',
    'color': '#497282'
  },
  {
    'title': 'E-Commerce Solutions',
    'icon': faShoppingCart,
    'details': 'Build secure and reliable e-commerce platforms with integrated payment gateways and inventory management systems that enable smooth online transactions.',
    'color': '#497282'
  },
  {
    'title': 'Social Media Marketing',
    'icon': faBullhorn,
    'details': 'We help you grow your online presence by creating and managing targeted social media campaigns, SEO strategies, and online advertising to increase engagement and drive traffic.',
    'color': '#497282'
  },
  {
    'title': 'Cloud Hosting Solutions',
    'icon': faCloud,
    'details': 'Our cloud hosting solutions provide fast, reliable, and scalable hosting options for your website or application, ensuring maximum uptime and security.',
    'color': '#497282'
  },
  {
    'title': 'Business Analytics and Consulting',
    'icon': faChartLine,
    'details': 'Leverage our business analytics and consulting services to gain actionable insights, make informed decisions, and boost your growth through data-driven strategies.',
    'color': '#497282'
  }
];

export default SERVICES_DATA;
